import { useMemo } from 'react';
import { useRoomListLoading, useStyledRoomList } from 'shared-state/directory/hooks';
import { useIdentityClaims } from 'shared-state/identity/hooks';
import { sortRoomList } from './helpers';

export interface CommonRoomListState {
    enableCreateRoomButton?: boolean;
    commonRoomIds: string[];
    isCommonRoomsLoading: boolean;
}
const useCommonRoomListState: () => CommonRoomListState = () => {
    const commonRooms = useStyledRoomList();
    const [isCommonRoomsLoading] = useRoomListLoading();
    const [identityClaims] = useIdentityClaims();
    const enableCreateRoomButton = identityClaims?.roles.includes('manager') || identityClaims?.roles.includes('owner');
    const commonRoomIds = useMemo(() => {
        return sortRoomList(commonRooms).map((r: any) => r.id);
    }, [commonRooms]);

    return { enableCreateRoomButton, commonRoomIds, isCommonRoomsLoading };
};
export default useCommonRoomListState;
